import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { BASE_URL } from "../env";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
// import { CSVExport } from 'react-bootstrap-table2-toolkit';
import filterFactory, {
	textFilter,
	selectFilter,
} from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";
// import { CSVLink} from "react-csv";
const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

const SingleCourseDashboard = (props) => {
	// const { ExportCSVButton } = CSVExport;
	// const [courses, setCourses] = useState([]);
	// const [email, setEmail] = useState();
	const [courseData, setCourseData] = useState({});
	// const [inProgress, setInProgress] = useState("");
	// const [progress, setProgress] = useState([]);
	let { course } = useParams();
	// let location = useLocation();

	let priceFilter;
	// let alldata = location.state[0];
	const [alldata, setalldata] = useState([]);
	const [studentdata, setstudentdata] = useState([]);
	const [tabledata, settabledata] = useState([]);
	// const {course} = useParams();
	// let totalVideos = alldata.videos.length;
	const [totalVideos, settotalVidoes] = useState("");

	console.log(alldata);
	useEffect(() => {
		showData();
		GetCourseData();
	}, []);

	function GetCourseData() {
		// alert(course)
		fetch(BASE_URL + "/getCourse/" + course, {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((dta) => {
				console.log(dta);
				setalldata(dta.data[0]);

				//   setalldata(dta)
			});
	}

	useEffect(() => {
		console.log(alldata);
		settotalVidoes(alldata?.videos?.length);
	}, [alldata]);

	function showData() {
		fetch(BASE_URL + "/studentsbycourse/" + course, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((res) => res.json())
			.then((data) => {
				console.log("students", data);
				setCourseData(data);
				setstudentdata(data?.Find);
			});
	}
	let newdata = [];
	useEffect(() => {
		console.log(studentdata);
		for (var i = 0; i < studentdata.length; i++) {
			var index = 1;
			for (var j = 0; j < studentdata[i]?.smallCourses.length; j++) {
				if (studentdata[i].smallCourses[j].courseId == course) {
					index = j;
					break;
				}
			}
			var tot_progress = 0;
			for (
				var j = 0;
				j < studentdata[i]?.smallCourses[index].video_progress.length;
				j++
			) {
				var progress =
					studentdata[i]?.smallCourses[index]?.video_progress[j]
						?.progress;
				tot_progress += parseInt(progress);
			}
			tot_progress /= 60;
			newdata.push({
				sno: i + 1,
				email: studentdata[i]?.user?.email,
				numLogin: studentdata[i]?.user?.numLogin,
				firstName: studentdata[i]?.user?.firstName,
				progress: (
					(studentdata[i]?.smallCourses[index]?.progress?.length /
						totalVideos) *
					100
				).toFixed(2),
				question_solved:
					studentdata[i]?.smallCourses[index]?.compiler_array.length,
				minutes_watched: tot_progress,
				times_visited:
					studentdata[i]?.smallCourses[index]?.times_visited,
				last_visited: studentdata[i]?.smallCourses[index]?.last_visited,
				totalSessions:
					studentdata[i]?.smallCourses[index]?.totalSessions,
				totalTime: studentdata[i]?.smallCourses[index]?.totalTime,
				sessionTime: studentdata[i]?.smallCourses[index]?.sessionTime,
			});
		}
		settabledata(newdata);
		console.log(JSON.stringify(newdata));
	}, [courseData, studentdata]);

	const selectOptions = {
		"CSE B1": "CSE B1",
		"CSE B2": "CSE B2",
		"CSE B3": "CSE B3",
		"CSE B4": "CSE B4",
		"CSE B5": "CSE B5",
		"CSE B6": "CSE B6",
		"CSE B7": "CSE B7",
		"CSE B8": "CSE B8",
		"CSE B9": "CSE B9",
		CSEB10: "CSEB10",
		CSEB11: "CSEB11",
		"ECE A1": "ECE A1",
		"ECE A2": "ECE A2",
	};

	const headers = [
		{ label: "S no", key: "S no" },
		{
			label: "FirstName",
			key: "FirstName",
		},
		{
			label: "Email",
			key: "Email",
		},
		{
			label: "Question Solved",
			key: "Question Solved",
		},
		{
			label: "Num Of Login",
			key: "Num Of Login",
		},
		{
			label: "Minutes Watched",
			key: "Minutes Watched",
		},

		{
			label: "Progress",
			key: "Progress",
		},
		{
			label: "times_visited",
			key: "times_visited",
		},
		{
			label: "last_visited",
			key: "last_visited",
		},
		{
			label: "totalSessions",
			key: "totalSessions",
		},
		{
			label: "totalTime",
			key: "totalTime",
		},
		{
			label: "sessionTime",
			key: "sessionTime",
		},
	];
	const tableHeaderStyle = { width: "5%", backgroundColor: "black" };
	const columns = [
		{
			dataField: "sno",
			text: "S no.",
			sort: true,
			headerStyle: () => {
				return { width: "5%", backgroundColor: "black" };
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
		},
		{
			dataField: "firstName",
			text: "FirstName",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "email",
			text: "Email",
			sort: true,
			filter: textFilter(),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "progress",
			text: "Progress",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "sessionTime",
			text: "sessionTime",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "totalTime",
			text: "totalTime",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "totalSessions",
			text: "totalSessions",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "question_solved",
			text: "Question Solved",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "numLogin",
			text: "Num Of Login",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "minutes_watched",
			text: "Minutes Watched",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return { width: "10%", backgroundColor: "black" };
			},
		},
		{
			dataField: "times_visited",
			text: "Number of Visits",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return tableHeaderStyle;
			},
		},
		{
			dataField: "last_visited",
			text: "Last Visited",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
			}),
			headerStyle: () => {
				return tableHeaderStyle;
			},
		},
	];

	// const handleClick = () => {
	// 	priceFilter('');
	//   };
	const [rowcount, setRowcount] = useState(tabledata.length);
	const handleDataChange = ({ dataSize }) => {
		setRowcount(dataSize);
	};
	const numberStyle = {
		border: "2px solid black",
		boxShadow: "4px 4px rgba(93, 93, 93)",
		borderRadius: "20px",
		fontFamily: "Poppins-Bold",
		color: "white",
	};
	return (
		<>
			<div className="text-centre my-5">
				<h1
					style={{
						fontFamily: "Poppins-Bold",
						color: "#185adb",
						textAlign: "center",
					}}
				>
					{alldata.name}
				</h1>
			</div>

			<div
				className="container-fluid d-flex"
				style={{ justifyContent: "space-evenly", height: "80px" }}
			>
				<div className="p-4 bg-dark " style={numberStyle}>
					Number of videos : {totalVideos}
				</div>
				<div>
					<img
						style={{ marginTop: "-40px" }}
						width={alldata?.image ? "150px" : "0px"}
						src={alldata.image}
					/>
				</div>
				<div className="p-4 bg-dark " style={numberStyle}>
					Number of Students : {courseData?.count}
				</div>
			</div>
			{/* <link href="https://unpkg.com/bootstrap-table@1.18.3/dist/bootstrap-table.min.css" rel="stylesheet"> */}
			<br />
			<br />

			<div className="mx-2 w-25 p-3 bg-dark " style={numberStyle}>
				Row Count:<span style={{ color: "yellow" }}>{rowcount}</span>
			</div>
			{/* <h5>Row Count:<span style>{rowcount}</span></h5> */}

			<div className="text-center my-5">
				<ToolkitProvider
					keyField={"sno"}
					data={tabledata}
					columns={columns}
					exportCSV={{
						fileName: "cantileverlabs_displayedData.csv",
						blobType: "text/csv;charset=ansi",
						onlyExportFiltered: true,
						exportAll: false,
					}}
					search
				>
					{(props) => (
						<div>
							<ExportCSVButton
								{...props.csvProps}
								className="btn btn-md bg-warning my-2"
								style={{ borderRadius: "10px" }}
							>
								Download All Data
							</ExportCSVButton>
							{/* <hr /> */}
							<br />
							<SearchBar {...props.searchProps} />
							<br />
							<br />
							<BootstrapTable
								{...props.baseProps}
								filter={filterFactory()}
								onDataSizeChange={handleDataChange}
								condensed
								bootstrap4
								loading
								classes="text-white"
								rowStyle={{
									backgroundColor: "black",
									color: "rgb(219, 219, 20)",
								}}
							/>
						</div>
					)}
				</ToolkitProvider>

				{/* <CSVLink className="btn btn-md bg-warning my-2" style={{borderRadius:"10px"}} data={tabledata} headers={headers}>
	Download All Data
	</CSVLink>

			<BootstrapTable keyField={'sno'} data={ tabledata } columns={ columns }  filter={ filterFactory()}	
					condensed
					bootstrap4
					loading
					classes="text-white"		
					rowStyle={ { backgroundColor: 'black',color:"rgb(219, 219, 20)" } }
				/> */}
			</div>
		</>
	);
};

export default SingleCourseDashboard;
